import React, { useEffect, useMemo, useState } from 'react'
import Breadcrumbs from 'components/atomic/Breadcrumbs'
import MetaSeo from 'components/atomic/MetaSeo'
import { api } from 'utils'
import { PAGINEDETAIL, LIBROAUXILIA } from 'utils/endpoint'
import { CardAdozionale } from 'react-components/molecules'
import { FiltriCatalogo } from 'react-components/organisms'
import { useTrans } from 'hooks'
import useCatalogo from 'hooks/useCatalogo'
import { sendProductImpressionGTM } from '../../utils/gtm'
import { useRouter } from 'next/router'

const LibroAuxiliaAll = ({ items, pagina }) => {
  const [libriAuxilia, setLibriAuxilia] = useState(items)
  const [gtmSent, setGtmSent] = useState(false)
  const router = useRouter()
  const { getUniqueFilters, getAttributi, toggleFilter } = useCatalogo(
    items,
    setLibriAuxilia,
    setGtmSent
  )

  const tipi = useMemo(() => getUniqueFilters('tipo-libroauxilia', ''), [items])

  const t = useTrans()
  useEffect(() => {
    if (!router.asPath.includes('filtri') && libriAuxilia && !gtmSent) {
      sendProductImpressionGTM(libriAuxilia, 'navigazione_standard')
      setGtmSent(true)
    }
  }, [libriAuxilia])

  return (
    <main className="catalogo">
      <MetaSeo seo={pagina.seo} />
      <div className="catalogo__container">
        <Breadcrumbs breadcrumbs={pagina.breadcrumbs} />
        <h1 className="catalogo__titolo">{pagina.titolo}</h1>
        <h2 className="catalogo__descrizione">{pagina.descrizione}</h2>
        <div className="catalogo__filtri">
          <FiltriCatalogo
            className="catalogo__classi"
            label={t('Filtra per tipologia')}
            filtri={getAttributi(tipi)}
            onClick={toggleFilter}
            visible
          />
        </div>
      </div>
      <div className="catalogo__round-corner">
        <div className="catalogo__list">
          {libriAuxilia.map((item, index) => (
            <CardAdozionale
              adozionale={item}
              key={item.id}
              position={index + 1}
              parentList={'navigazione_standard'}
            />
          ))}
        </div>
      </div>
    </main>
  )
}

export const getStaticProps = async () => {
  const response = await api.get(LIBROAUXILIA)
  const items = response.data
  const pageResponse = await api.get(PAGINEDETAIL, {
    params: {
      chiave: 'libroauxilia-all',
    },
  })
  const pagina = await pageResponse.data

  const toolbarProps = { toolbarPage: pagina }

  return { props: { items, pagina, ...toolbarProps }, revalidate: 60 * 2 }
}

export default LibroAuxiliaAll
